// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__11OFl","right":"styles_right__3d5Mu"};